import { render } from "./taxonomy-filter.vue?vue&type=template&id=4b824314"
import script from "./taxonomy-filter.vue?vue&type=script&lang=js"
export * from "./taxonomy-filter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MAMP\\htdocs\\vetpartners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/vacancies/filter/taxonomy-filter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b824314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b824314', __exports__)) {
    console.log('reload')
    api.reload('4b824314', __exports__)
  }
  
  module.hot.accept("./taxonomy-filter.vue?vue&type=template&id=4b824314", () => {
    console.log('re-render')
    api.rerender('4b824314', render)
  })

}


export default __exports__